import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

import Bottom from './Bottom';
import {
  FlexContainer,
  BodyContainer,
  Block,
  Content,
  MobileHeading,
  ShareGroupContainer,
  InfoContainer,
  MainContentContainer,
  OuterContainer,
} from './styles/_main';
import Initial from './Initial';
import Details from './Details';
import Payment from './Payment';
import Confirmation from './Confirmation';
import PurchaseError from './PurchaseError';
import InfoBlock from './InfoBlock';
import SmallSpinner from 'app/components/spinner/smallSpinner';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import AddressInfo from './AddressInfo';
import ShareGroup from './common/ShareGroup';

const Main = observer(() => {
  const stepContainerRef = useRef(null);
  const {
    step,
    INITIAL,
    CONFIRMATION,
    DETAILS,
    PAYMENT,
    PURCHASE_ERROR,
    setFormDefaults,
  } = form;
  const { activeObject } = view;
  const { type } = activeObject;

  useEffect(() => {
    setFormDefaults();
  }, []);

  useEffect(() => {
    if (stepContainerRef.current && step !== INITIAL) {
      stepContainerRef.current.focus();
    }
  }, [step, INITIAL]);

  let currentComp = null;
  let headerText = '';
  let ariaContainerLabel = '';

  switch (step) {
    case INITIAL:
      currentComp = <Initial />;
      headerText = i18n.gettext('Tickets');
      ariaContainerLabel = i18n.sprintf(
        i18n.gettext('%s Purchase'),
        type === 'event' ? i18n.gettext('Ticket') : i18n.gettext('Coupon')
      );
      break;

    case DETAILS:
      currentComp = <Details />;
      headerText = i18n.gettext('Personal Details');
      ariaContainerLabel = i18n.gettext('Contact Details');
      break;

    case PAYMENT:
      currentComp = <Payment />;
      headerText = i18n.gettext('Payment');
      ariaContainerLabel = i18n.gettext('Payment Details');
      break;

    case CONFIRMATION:
      currentComp = <Confirmation />;
      headerText = '';
      ariaContainerLabel = i18n.sprintf(
        i18n.gettext('%s purchase confirmation'),
        type === 'event' ? i18n.gettext('Ticket') : i18n.gettext('Coupon')
      );
      break;

    case PURCHASE_ERROR:
      currentComp = <PurchaseError />;
      break;
  }

  const { show_share_buttons: showShareButtons } = activeObject || {};

  if (!activeObject) return <SmallSpinner />;

  return (
    <OuterContainer>
      <FlexContainer>
        <BodyContainer>
          <Block>
            <Content>
              <InfoContainer>
                <InfoBlock />
                <AddressInfo />
              </InfoContainer>
              <MainContentContainer
                ref={stepContainerRef}
                role="region"
                tabIndex={0}
                aria-live="assertive"
                aria-label={ariaContainerLabel}
              >
                <MobileHeading>{headerText}</MobileHeading>
                {currentComp}
                {step === INITIAL && showShareButtons ? (
                  <ShareGroupContainer>
                    <ShareGroup />
                  </ShareGroupContainer>
                ) : null}
              </MainContentContainer>
            </Content>
          </Block>
        </BodyContainer>
        <Bottom />
      </FlexContainer>
    </OuterContainer>
  );
});

export default Main;
